import React from "react";

const TICKET_TYPES = ["Help", "Dispute", "Complaint", "Payment"];

const statusMeta = (status) => {
  if (status === "Resolved") {
    return { bg: "#ffffff", color: "#000000" };
  }

  if (status === "In Review") {
    return { bg: "#fff000", color: "#000000" };
  }

  return { bg: "#fff000", color: "#000000" };
};

const priorityMeta = (priority) => {
  if (priority === "High") {
    return { bg: "#000000", color: "#ffffff" };
  }

  if (priority === "Low") {
    return { bg: "#ffffff", color: "#000000" };
  }

  return { bg: "#fff000", color: "#000000" };
};

const SPT_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800;900&display=swap');

.spt-wrap {
  font-family: 'Raleway', sans-serif;
}

.spt-card {
  background: #ffffff;
  border: none;
  border-radius: 18px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  padding: 1.75rem;
  margin-bottom: 1.5rem;
}

.spt-heading {
  margin: 0 0 16px;
  font-size: 1.05rem;
  font-weight: 800;
  color: #000000;
}

.spt-ok-banner {
  background: #fff000;
  border: none;
  border-radius: 13px;
  padding: 12px 16px;
  font-size: .85rem;
  color: #000000;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 18px;
}

.spt-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 700px) {
  .spt-form-grid {
    grid-template-columns: 1fr;
  }
}

.spt-lbl {
  display: block;
  font-size: .68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #000000;
  margin-bottom: 6px;
}

.spt-inp,
.spt-sel,
.spt-ta {
  width: 100%;
  padding: 11px 13px;
  font-size: .87rem;
  border: none;
  border-radius: 11px;
  background: #f7f7f7;
  color: #000000;
  font-family: 'Raleway', sans-serif;
  outline: none;
  transition: background .2s, box-shadow .2s;
  font-weight: 500;
  box-sizing: border-box;
}

.spt-inp:focus,
.spt-sel:focus,
.spt-ta:focus {
  border: none;
  background: #ffffff;
  box-shadow: 0 0 0 2px #fff000;
}

.spt-ta {
  resize: vertical;
  min-height: 95px;
}

.spt-submit-btn {
  width: 100%;
  padding: 13px;
  font-size: .9rem;
  font-weight: 800;
  background: #fff000;
  color: #000000;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  font-family: 'Raleway', sans-serif;
  transition: transform .18s, box-shadow .18s, background .18s, color .18s;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spt-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  background: #000000;
  color: #ffffff;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
}

.spt-submit-btn:disabled {
  opacity: .55;
  cursor: not-allowed;
  transform: none;
}

.spt-spinner,
.spt-spinner-white {
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  animation: spt-spin .7s linear infinite;
}

.spt-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 0, 0, .15);
  border-top-color: #000000;
}

.spt-spinner-white {
  width: 16px;
  height: 16px;
  border: 2.5px solid rgba(0, 0, 0, .25);
  border-top-color: #000000;
}

@keyframes spt-spin {
  to {
    transform: rotate(360deg);
  }
}

.spt-tbl-wrap {
  overflow-x: auto;
}

.spt-tbl {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.spt-tbl th {
  background: #000000;
  font-size: .66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #ffffff;
  padding: 12px 16px;
  text-align: left;
  border: none;
  white-space: nowrap;
}

.spt-tbl td {
  padding: 13px 16px;
  border: none;
  font-size: .85rem;
  vertical-align: middle;
  color: #000000;
}

.spt-tbl tr:last-child td {
  border: none;
}

.spt-tbl tbody tr {
  transition: background .18s;
}

.spt-tbl tbody tr:hover {
  background: #fff000;
}

.spt-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 50px;
  padding: 4px 11px;
  font-size: .68rem;
  font-weight: 700;
  white-space: nowrap;
  border: none;
}

.spt-empty {
  text-align: center;
  padding: 2.5rem 1rem;
}

.spt-empty-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 auto 14px;
  background: #fff000;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.spt-empty h3 {
  font-size: .95rem;
  font-weight: 800;
  color: #000000;
  margin: 0 0 4px;
}

.spt-empty p {
  font-size: .82rem;
  color: #000000;
  margin: 0;
}
`;

export default function SupportTab({
  ticketForm,
  onFormChange,
  onSubmit,
  busy,
  ok,
  tickets,
  ticketsLoading,
}) {
  return (
    <>
      <style>{SPT_CSS}</style>

      <div className="spt-wrap">

        <div className="spt-card">
          <h2 className="spt-heading">
            Raise a Support Ticket
          </h2>

          {ok && (
            <div className="spt-ok-banner">
              <i className="fas fa-check-circle" />
              Ticket submitted! Our support team will get back to you shortly.
            </div>
          )}

          <form onSubmit={onSubmit}>
            <div className="spt-form-grid">

              <div>
                <label
                  className="spt-lbl"
                  htmlFor="type"
                >
                  Issue type
                </label>

                <select
                  id="type"
                  className="spt-sel"
                  value={ticketForm.type}
                  onChange={onFormChange}
                >
                  {TICKET_TYPES.map((t) => (
                    <option
                      key={t}
                      value={t}
                    >
                      {t}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  className="spt-lbl"
                  htmlFor="subject"
                >
                  Subject
                </label>

                <input
                  id="subject"
                  type="text"
                  className="spt-inp"
                  placeholder="Brief summary"
                  value={ticketForm.subject}
                  onChange={onFormChange}
                  required
                />
              </div>

              <div style={{ gridColumn: "1 / -1" }}>
                <label
                  className="spt-lbl"
                  htmlFor="message"
                >
                  Message
                </label>

                <textarea
                  id="message"
                  className="spt-ta"
                  rows={4}
                  placeholder="Describe your issue…"
                  value={ticketForm.message}
                  onChange={onFormChange}
                  required
                />
              </div>

            </div>

            <button
              type="submit"
              className="spt-submit-btn"
              disabled={busy}
            >
              {busy ? (
                <>
                  <span className="spt-spinner-white" />
                  Sending…
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane" />
                  Submit Ticket
                </>
              )}
            </button>
          </form>
        </div>

        <div
          className="spt-card"
          style={{
            padding: 0,
            overflow: "hidden",
          }}
        >

          <div
            style={{
              padding: "22px 24px 0",
            }}
          >
            <h2
              className="spt-heading"
              style={{
                margin: 0,
              }}
            >
              Your Tickets
            </h2>
          </div>

          {ticketsLoading ? (

            <div
              style={{
                padding: "2rem",
                textAlign: "center",
              }}
            >
              <span className="spt-spinner" />
            </div>

          ) : !tickets || tickets.length === 0 ? (

            <div
              style={{
                padding: "2.25rem",
              }}
            >
              <div className="spt-empty">

                <div className="spt-empty-icon">
                  <i className="fas fa-question-circle" />
                </div>

                <h3>
                  No tickets yet
                </h3>

                <p>
                  Tickets you raise will show up here with their status.
                </p>

              </div>
            </div>

          ) : (

            <div className="spt-tbl-wrap">

              <table className="spt-tbl">

                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Priority</th>
                    <th>Raised</th>
                  </tr>
                </thead>

                <tbody>

                  {tickets.map((t) => {
                    const sm = statusMeta(t.status);
                    const pm = priorityMeta(t.priority);

                    return (
                      <tr key={t.id}>

                        <td>
                          <strong>
                            {t.subject}
                          </strong>

                          {t.message && (
                            <p
                              style={{
                                fontSize: ".76rem",
                                color: "#000000",
                                marginTop: 2,
                                marginBottom: 0,
                              }}
                            >
                              {t.message.slice(0, 80)}
                              {t.message.length > 80 ? "…" : ""}
                            </p>
                          )}
                        </td>

                        <td>
                          {t.type}
                        </td>

                        <td>
                          <span
                            className="spt-badge"
                            style={{
                              background: sm.bg,
                              color: sm.color,
                            }}
                          >
                            {t.status}
                          </span>
                        </td>

                        <td>
                          <span
                            className="spt-badge"
                            style={{
                              background: pm.bg,
                              color: pm.color,
                            }}
                          >
                            {t.priority}
                          </span>
                        </td>

                        <td
                          style={{
                            fontSize: ".8rem",
                            color: "#000000",
                          }}
                        >
                          {new Date(
                            t.created_at
                          ).toLocaleDateString("en-KE", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>

                      </tr>
                    );
                  })}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>
    </>
  );
}

